
export type PagePurpose =
  "normal"
  | "home page"
  | "opening hours"
  | "---"
  | "error"
  | "events collection"
  | "event detail"
  | "floor map"
  | "lunch"
  | "offers collection"
  | "search"
  | "stores collection"
  | "store detail"
  | "privacy policy"
  | "campaign"
  | "custom1"
  | "custom2"
  | "custom3";


export const page_purpose_index: Omit<PagePurpose, '---'>[] = [
    "normal",
    "home page",
    "opening hours",
    "error",
    "events collection",
    "event detail",
    "floor map",
    "lunch",
    "offers collection",
    "search",
    "stores collection",
    "store detail",
    "privacy policy",
    "campaign",
    "custom1",
    "custom2",
    "custom3",
  ];

export type RouterReply = PageReply | RedirectReply;

export type PageReply = {
  locale: string;
  page: SitePageSpec;
  friendly_url_path_api: string;
  params: PageParams;
}

export type RedirectReply = {
  redirect: string;
  permanent: boolean;
  params?: PageParams;
}

export type KnownParams = "slug" | "entity_id" | "id" | "lang" | "locale" | "fob_slug";
export type PageParams = Partial<Record<KnownParams, string>>;
